
import * as React from "react";
import CountDownComp from "../../global/CountDownComp";
import { ISetUrl } from "../../../AppMain";
import { IActiveOrders } from "../../../interfaces/IOrder";
import DateTool from "../../../../avernus/datetool/source/DateTool";
import { Api } from "../../../lib/Api";
import { Lng } from "../../../../languages/Languages";
import Header from "../../Header";
import CancelButton from "./buttons/CancelButton";
import SendProblemButton from "./buttons/SendProblemButton";
import AcceptButton from "./buttons/AcceptButton";
import CompletedButton from "./buttons/CompletedButton";
import ReviewButton from "./buttons/ReviewButton";

interface IOrderButtonProps {
    order: any
    setUrl: any
}

interface IOrderButtonState {
}



export default class OrderButton extends React.Component<IOrderButtonProps, IOrderButtonState>{

    constructor(props:IOrderButtonProps){
        super(props);
        this.state = {

        };


    }


    render() {

        let order = this.props.order;
        return (
            <div className = "buttons-box">
                <AcceptButton order={order} setUrl={this.props.setUrl} />
                <CompletedButton order={order} setUrl={this.props.setUrl} />
                <SendProblemButton order={order} setUrl={this.props.setUrl} />
                <CancelButton order={order} setUrl={this.props.setUrl} />
                <ReviewButton order={order} setUrl={this.props.setUrl} />

                <div className = "row">
                    <div className = "col-md-12">
                        <div className = "back-btn">
                            <button className="back_btn" onClick={() => this.props.setUrl('/user/index')}>Back</button>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}
